<template>
  <div>
    <div class="row">
      <div class="col">
        <div class="indent">
          <strong>
            <a @click="showViewModal = true" v-if="item.description">{{name}}</a>
            <span v-else>{{name}}</span>
            <pf-actions :item="item.actions"></pf-actions>
          </strong>
          <strong v-if="item.detail">({{ item.detail }})</strong>
          <span class="item-description" v-if="item.summary">- {{ item.summary }}</span>
        </div>
      </div>
      <div class="col-flex" v-if="canEdit">
        <a :id="`${section}-${item._id}`" @click="$emit('setId')" class="cogs125 modal-toggle">
          <i class="fa fa-cog"></i>
        </a>
      </div>
    </div>

    <ez-modal v-if="showViewModal" @close="showViewModal = false" :size="modalSize">
      <display :item="item"></display>
    </ez-modal>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import Display from "./_Display.vue";
import modal from "@/mixins/vue-ez-modal";
import PfActions from "@/components/shared/_PfActions.vue";

export default {
  name: "sheet-rules-rule",
  mixins: [modal],
  components: {
    Display,
    PfActions
  },
  props: ["section", "single", "item", "ruleset"],
  data() {
    return {
      showViewModal: false,
      showEditModal: false
    };
  },
  watch: {
    item: "updateFromRef"
  },
  computed: {
    ...mapGetters({ canEdit: "characters/canEdit" }),
    name() {
      return this.item.name || this.single;
    },
    modalSize() {
      if (this.$rulesets[this.ruleset].ruleTypes.includes(this.single))
        return "m-medium";
      return "m-large";
    }
  },
  methods: {
    updateFromRef() {
      if (this.item._ref) {
        this.$rpgv.updateFromRef(this.item);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.action-group {
  position: relative;
  top: -0.2em;
}
.action-base {
  vertical-align: middle;
  line-height: 0.5rem;
}
.actions {
  margin-left: -0.4em;
  font-size: 1.4em;
  line-height: 0.5rem;
  vertical-align: middle;
  cursor: pointer;
}
</style>
